import { render, staticRenderFns } from "./eveningcounsellingDetail.vue?vue&type=template&id=9d19c954&"
import script from "./eveningcounsellingDetail.vue?vue&type=script&lang=js&"
export * from "./eveningcounsellingDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports